/*eslint-disable*/

import Amplify from '@aws-amplify/auth';
import env from '../config/env';

export default function init() {
  Amplify.configure({
    Auth: {
      region: env.REACT_APP_AWS_REGION,
      userPoolId: env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: env.REACT_APP_USER_POOL_WEB_CLIENT_ID
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/cognitoInitializer.js